import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'modal-ncs-documents',
  templateUrl: 'modal-ncs-documents.component.html',
  styleUrls: ['../../../app.component.scss']
})
export class ModalNcsDocuments implements OnInit {
  @Input() public nc_urls: { document_url: string, document_nop_url: string }[] = []
  @Input() public code: string = ''
  @Input() public name: string = ''

  url = ''

  constructor(
    public modal: NgbActiveModal,
  ) {}

  ngOnInit(): void {
    // console.log(this.nc_urls.length !== 0 && this.nc_urls[0].document_url)
    // console.log(this.nc_urls.length !== 0, this.nc_urls[0].document_url)
    if(this.nc_urls.length !== 0 && this.nc_urls[0].document_url) {
      this.url = this.nc_urls[0].document_url
    }
  }

  show(documentUrl: string) {
    this.url = documentUrl
  }
}